module Index

open Elmish
open Elmish.Navigation
open Fable.Remoting.Client
open Shared
open Slider
open Router

type Page =
    | Home
    | Pixie
    | Bargarn
    | Touchpoint
    | Shelfinity
    | SBH
    | Effecta
    | Bidflowcom
    | Endurance
    | Direktpress

type State =
    { CurrentPage: Page }

type Msg =
    | Logout
    | NavigateTo of Route

let urlUpdate (nextPage : Route option) (state:State) =
    match nextPage with
    | Some Route.Home -> { state with CurrentPage = Home }, Cmd.none
    | Some Route.Pixie -> { state with CurrentPage = Pixie }, Cmd.none
    | Some Route.Bargarn -> { state with CurrentPage = Bargarn }, Cmd.none
    | Some Route.Touchpoint -> { state with CurrentPage = Touchpoint }, Cmd.none
    | Some Route.Shelfinity -> { state with CurrentPage = Shelfinity }, Cmd.none
    | Some Route.SBH -> { state with CurrentPage = SBH }, Cmd.none
    | Some Route.Effecta -> { state with CurrentPage = Effecta }, Cmd.none
    | Some Route.Bidflowcom -> { state with CurrentPage = Bidflowcom }, Cmd.none
    | Some Route.Endurance -> { state with CurrentPage = Endurance }, Cmd.none
    | Some Route.Direktpress -> { state with CurrentPage = Direktpress }, Cmd.none
    | None -> { state with CurrentPage = Home }, Cmd.none

let init page: State * Cmd<Msg> =
    let model =
        { CurrentPage = Home }
    urlUpdate page model

let update (msg: Msg) (state: State): State * Cmd<Msg> =
    match msg with
    | Logout -> state, Cmd.none
    | NavigateTo route ->
        state, Navigation.newUrl (Router.toPath route)

open Feliz
open Fable

let view (state:State) (dispatch: Msg -> unit)  =
    let navigate route = dispatch (NavigateTo route)
    match state.CurrentPage with
    | Home -> Home.Render navigate
    | Pixie -> Components.Project.View 6 navigate
    | Bargarn -> Components.Project.View 7 navigate
    | Touchpoint -> Components.Project.View 8 navigate
    | Shelfinity -> Components.Project.View 9 navigate
    | SBH -> Components.Project.View 3 navigate
    | Effecta -> Components.Project.View 2 navigate
    | Bidflowcom -> Components.Project.View 1 navigate
    | Endurance -> Components.Project.View 4 navigate
    | Direktpress -> Components.Project.View 5 navigate